import { useNavigate } from "react-router-dom";
import Button from "../../components/button";
import styles from "./styles.module.css";

const NoPermission = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h3 className={styles.title}>
          No tienes permisos para acceder a esta sección
        </h3>
        <div className={styles.actions}>
          <Button variant="primary" onClick={() => navigate("/last")}>
            Ir al inicio
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NoPermission;
